import { readonly, ref } from 'vue'

/**
 * 轻提示。
 *
 * 用在「保存成功」「已停用」这类操作反馈上。这些事情用户需要知道发生了，
 * 但不需要为它点一次确定——弹框要求确认会把一个两秒的操作变成四秒。
 *
 * <h2>为什么状态放在模块作用域</h2>
 * 队列是全局唯一的：任何组件在任何位置调 toast，都显示在屏幕同一个地方。
 * 如果做成每个组件实例一份，就会出现两个提示叠在一起、或者提示随着
 * 触发它的组件被卸载而闪现即逝——后者在「保存成功后关闭弹层」的流程里必然发生。
 */
const messages = ref([])
let nextId = 1

/** 提示停留时长。够读完一句短话，又不至于挡住下一步操作。 */
const DURATION_MS = 2600

/**
 * @param {string} text
 * @param {'success' | 'error'} type
 */
function push(text, type) {
  const id = nextId++
  messages.value.push({ id, text, type })

  setTimeout(() => {
    messages.value = messages.value.filter((m) => m.id !== id)
  }, DURATION_MS)
}

export function useToast() {
  return {
    /** 成功反馈。 */
    success: (text) => push(text, 'success'),

    /**
     * 失败反馈。
     *
     * 只用于「操作失败但页面还能用」的场景，比如保存被后端拒绝。
     * 整页加载失败不该用 toast——那种情况页面上是空的，
     * 一个两秒后消失的提示会让用户对着空白页不知所措，应该用 AsyncSection 的错误态。
     */
    error: (text) => push(text, 'error'),
  }
}

/** 给 ToastHost 用的只读队列。业务代码不该直接改它。 */
export function useToastQueue() {
  return readonly(messages)
}
